import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  Tooltip,
  TablePagination,
  Box,
  Typography,
  IconButton,
  SvgIcon,
  Collapse,
  Divider,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import mime from 'mime-types';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {
  TableSkeleton,
  Spinner,
  dateFormatterTime,
  LabeledLinearProgress,
  dateFormatterDate,
} from '@shared/components';
import { getSortDirection, handleSortChange } from '../../../utils/sortHelpers';
import useGlobalAlertContext from '../../../hooks/useGlobalAlertContext';
import axios from '../../../utils/axios';
import useAuthContext from '../../../hooks/useAuthContext';
import useTheme from '../../../hooks/useTheme';
import { ErrorMessage, ExpandableRowCell, ExpandedRow } from './style';

const tableProperties = {
  headColumn: '6%',
  tailColumn: '21%',
  columns: [
    {
      value: 'id',
      name: 'ID',
      sortName: 'ID-u',
      width: '8%',
    },
    {
      value: 'dateCreated',
      name: 'Datum kreiranja',
      sortName: 'datumu kreiranja',
      width: '12%',
    },
    {
      value: 'protocolNumber',
      name: 'Broj protokola',
      sortName: 'broju protokola',
      width: '10%',
    },
    {
      value: 'responsiblePersonName',
      name: 'Odgovorna osoba',
      sortName: 'odgovornoj osobi',
      width: '11%',
    },
    {
      value: 'accordancePercentage',
      name: `Trenutni / Potrebni procenat saglasnosti`,
      sortName: 'procentu saglasnosti',
      width: '24%',
    },
    {
      value: 'dateModified',
      name: `Datum posljednje izmjene `,
      sortName: 'procentu saglasnosti',
      width: '10%',
    },
  ],
};
// @ TODO - kolona odgovorna osoba!!!
const ExpandableRow = ({
  document,
  setSelectedDocument,
  setDocumentModalVisible,
  setStatusModalVisible,
  setWorkerOrgModalVisible,
  selectedDocument,
  downloadLoading,
  getDocumentFile,
}) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { user } = useAuthContext();
  const history = useHistory();

  return (
    <>
      <TableRow key={document.id} style={{ borderBottom: 0 }}>
        <ExpandableRowCell>
          <IconButton size="small" onClick={() => setOpen((prevState) => !prevState)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </ExpandableRowCell>
        <ExpandableRowCell>{document.id}</ExpandableRowCell>
        <ExpandableRowCell>
          {dateFormatterDate(document.dateCreated)}
          <Typography variant="h6" color="textSecondary">
            {dateFormatterTime(document?.dateCreated)}
          </Typography>
        </ExpandableRowCell>
        <ExpandableRowCell>{document.protocolNumber}</ExpandableRowCell>
        <ExpandableRowCell>{document.responsiblePersonName}</ExpandableRowCell>
        <ExpandableRowCell>
          <Tooltip
            enterDelay={300}
            placement="top-start"
            arrow
            title={`Trenutno: ${document.currentPercentage}% Potrebno: ${document.accordancePercentage}% Max: 100%`}
          >
            <span>
              <LabeledLinearProgress
                value={document.currentPercentage}
                buffer={document.accordancePercentage}
                theme={theme}
              />
            </span>
          </Tooltip>
        </ExpandableRowCell>
        <ExpandableRowCell>
          {dateFormatterDate(document.dateModified)}
          <Typography variant="h6" color="textSecondary">
            {dateFormatterTime(document.dateModified)}
          </Typography>
        </ExpandableRowCell>
        <ExpandableRowCell width={215} align="right">
          <>
            {user.username === document.responsiblePersonUsername ? (
              <Tooltip enterDelay={300} placement="top-end" arrow title="Promjena statusa">
                <IconButton
                  style={{
                    color:
                      (document?.status === 2 ||
                        (document?.status === 3 &&
                          document.currentPercentage >= document.accordancePercentage)) &&
                      theme.palette.success.main,
                  }}
                  onClick={() => {
                    setSelectedDocument(document);
                    setStatusModalVisible(true);
                  }}
                >
                  <SvgIcon fontSize="small">
                    <SendOutlinedIcon />
                  </SvgIcon>
                </IconButton>
              </Tooltip>
            ) : null}
            <Tooltip enterDelay={300} placement="top-end" arrow title="Radnici/organizacije">
              <IconButton
                onClick={() => {
                  setSelectedDocument(document);
                  setWorkerOrgModalVisible(true);
                }}
              >
                <SvgIcon fontSize="small">
                  <AssignmentIndOutlinedIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip
              enterDelay={300}
              placement="top-end"
              arrow
              title={
                downloadLoading && document?.id === selectedDocument?.id ? '' : 'Prikaži dokument'
              }
            >
              {downloadLoading && document?.id === selectedDocument?.id ? (
                <span>
                  <IconButton size="small" disabled>
                    <Box pr={3}>
                      <Spinner color="primary" size={20} />
                    </Box>
                  </IconButton>
                </span>
              ) : (
                <span>
                  <IconButton
                    disabled={downloadLoading}
                    onClick={() => {
                      setSelectedDocument(document);
                      getDocumentFile(document.id, document.documentExtension);
                    }}
                  >
                    <SvgIcon fontSize="small">
                      <InsertDriveFileOutlinedIcon />
                    </SvgIcon>
                  </IconButton>
                </span>
              )}
            </Tooltip>
            <Tooltip enterDelay={300} placement="top-end" arrow title="Uredi dokument">
              <IconButton
                onClick={() => {
                  setSelectedDocument(document);
                  setDocumentModalVisible(true);
                }}
              >
                <SvgIcon fontSize="small">
                  <EditOutlinedIcon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip enterDelay={300} placement="top-end" arrow title="Detaljni pregled dokumenta">
              <span>
                <IconButton
                  onClick={() =>
                    history.push({
                      pathname: `/accordance/${document.id}`,
                    })
                  }
                >
                  <SvgIcon fontSize="small">
                    <ArrowForwardIcon />
                  </SvgIcon>
                </IconButton>
              </span>
            </Tooltip>
          </>
        </ExpandableRowCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan="100%" style={{ padding: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Divider light />
            <Box>
              <ExpandedRow>
                <Table size="small" aria-label="expanded">
                  <TableHead>
                    <TableRow>
                      <ExpandableRowCell width={tableProperties.headColumn} />
                      <ExpandableRowCell width="20%">Tip dokumenta</ExpandableRowCell>
                      <ExpandableRowCell width="22%">Broj stranica</ExpandableRowCell>
                      <ExpandableRowCell width="24%">Ekstenzija</ExpandableRowCell>
                      <ExpandableRowCell width="30%">Veličina fajla (bajt)</ExpandableRowCell>
                      <ExpandableRowCell width={tableProperties.tailColumn} />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      {/* VRIJEDNOSTI - Ovdje se dodaju vrijednosti. */}
                      <ExpandableRowCell />
                      <ExpandableRowCell>{document.documentTypeName || ''}</ExpandableRowCell>
                      <ExpandableRowCell>{document.documentNoPages || ''}</ExpandableRowCell>
                      <ExpandableRowCell>{document.documentExtension || ''}</ExpandableRowCell>
                      <ExpandableRowCell>{document.documentFilesize}</ExpandableRowCell>
                      <ExpandableRowCell />
                    </TableRow>
                  </TableBody>
                </Table>
              </ExpandedRow>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const DocumentsAccordanceTable = ({
  documents,
  page,
  setPage,
  totalCount,
  rowsPerPage,
  setRowsPerPage,
  error,
  loading,
  sorters,
  setSorters,
  setSelectedDocument,
  selectedDocument,
  setStatusModalVisible,
  setDocumentModalVisible,
  setWorkerOrgModalVisible,
}) => {
  const [downloadLoading, setDownloadLoading] = useState(false);
  const { sendErrorAlertData } = useGlobalAlertContext();

  const handleRowsPerPageChange = ({ target: { value } }) => {
    if (value * (page + 1) >= totalCount) setPage(Math.floor(totalCount / value));
    setRowsPerPage(value);
  };

  const getDocumentFile = async (id, extension) => {
    setDownloadLoading(true);
    try {
      const { data } = await axios.get(`get-document/${id}`);
      const { documentFile } = data;
      const url = window.URL.createObjectURL(
        new Blob([new Uint8Array(documentFile.data).buffer], {
          type: mime.lookup(extension) || 'application/pdf',
        }),
      );

      const link = document.createElement('a');
      link.href = url;

      // link.setAttribute('download', `dokument-${id}${extension}`);
      link.setAttribute('target', '_blank');

      link.click();
    } catch (documentError) {
      sendErrorAlertData(
        `${
          documentError?.response?.data ||
          documentError?.data?.error?.message ||
          `Došlo je do greške prilikom preuzimanja dokumenta`
        }`,
      );
    } finally {
      setDownloadLoading(false);
      setSelectedDocument(undefined);
    }
  };

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell width={40} />
          {tableProperties.columns.map((column) => (
            <TableCell key={column.value} align={column.align} width={column.width}>
              <Tooltip enterDelay={300} title={`Sortiraj prema ${column.sortName}`}>
                <TableSortLabel
                  active={!!getSortDirection(column.value, sorters)}
                  direction={getSortDirection(column.value, sorters)}
                  onClick={() => handleSortChange(column.value, sorters, setSorters)}
                >
                  {column.name}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
          <TableCell width={180} />
        </TableRow>
      </TableHead>
      <TableBody>
        {error ? (
          <TableRow>
            <TableCell align="center" colSpan="100%" height={5 * 70.33}>
              <Box display="flex" justifyContent="center">
                <ErrorOutlineRoundedIcon fontSize="large" />
                <ErrorMessage>{error?.data?.details?.reason || 'Došlo je do greške'}</ErrorMessage>
              </Box>
            </TableCell>
          </TableRow>
        ) : loading || !documents ? (
          <TableRow>
            <TableCell align="center" colSpan="100%" style={{ paddingTop: '0' }}>
              <TableSkeleton size={rowsPerPage} />
            </TableCell>
          </TableRow>
        ) : documents?.length === 0 ? (
          <TableRow>
            <TableCell align="center" colSpan="100%" height={80}>
              <Typography>Nije pronađen niti jedan dokument</Typography>
            </TableCell>
          </TableRow>
        ) : (
          documents?.map((document) => (
            <ExpandableRow
              key={document.id}
              document={document}
              selectedDocument={selectedDocument}
              setSelectedDocument={setSelectedDocument}
              setDocumentModalVisible={setDocumentModalVisible}
              setStatusModalVisible={setStatusModalVisible}
              downloadLoading={downloadLoading}
              getDocumentFile={getDocumentFile}
              setWorkerOrgModalVisible={setWorkerOrgModalVisible}
            />
          ))
        )}
        <TableRow>
          <TablePagination
            width="100%"
            count={totalCount}
            page={page}
            labelRowsPerPage="Broj redova po stranici"
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleRowsPerPageChange}
            rowsPerPageOptions={[5, 10, 20, 25]}
            onPageChange={(_, newPage) => setPage(newPage)}
          />
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default DocumentsAccordanceTable;
